// extracted by css-extract-rspack-plugin
export default {"root":"root-j2UpbZ"};